/** H0: @handle onboarding + search display — ko/en/vi/ru */

const handle = {
  title: [
    '핸들 정하기',
    'Choose your handle',
    'Chọn handle',
    'Выберите handle',
  ],
  subtitle: [
    '친구가 나를 찾을 때 쓰는 고유 ID예요',
    'Your unique ID for friends to find you',
    'ID duy nhất để bạn bè tìm bạn',
    'Уникальный ID, по которому вас найдут друзья',
  ],
  placeholder: [
    '영문_아이디',
    'your_handle',
    'ten_handle',
    'vash_handle',
  ],
  hint: [
    '소문자·숫자·언더스코어, 3~20자',
    'Lowercase letters, numbers, underscore, 3–20 chars',
    'Chữ thường, số, gạch dưới, 3–20 ký tự',
    'Строчные буквы, цифры, подчёркивание, 3–20 символов',
  ],
  checking: ['확인 중...', 'Checking...', 'Đang kiểm tra...', 'Проверка...'],
  available: ['사용 가능해요', 'Available', 'Có thể dùng', 'Доступно'],
  taken: ['이미 사용 중이에요', 'Already taken', 'Đã có người dùng', 'Уже занято'],
  invalid: ['사용할 수 없는 형식이에요', 'Invalid format', 'Định dạng không hợp lệ', 'Недопустимый формат'],
  reserved: ['예약된 핸들이에요', 'Reserved handle', 'Handle đã được giữ', 'Зарезервированный handle'],
  required: ['핸들을 입력해 주세요', 'Enter a handle', 'Nhập handle', 'Введите handle'],
  saveFailed: [
    '핸들 저장에 실패했어요',
    'Could not save handle',
    'Không lưu được handle',
    'Не удалось сохранить handle',
  ],
  searchPlaceholder: [
    '닉네임 또는 @핸들 검색',
    'Search nickname or @handle',
    'Tìm nickname hoặc @handle',
    'Поиск по нику или @handle',
  ],
  editSection: ['@핸들', '@handle', 'Tên @', 'Имя @'],
  editHint: [
    '친구가 나를 찾을 때 쓰는 고유 ID',
    'Your unique ID for friends to find you',
    'ID duy nhất để bạn bè tìm bạn',
    'Уникальный ID для поиска вас друзьями',
  ],
  notSet: ['아직 설정 안 함', 'Not set yet', 'Chưa đặt', 'Ещё не задан'],
  changeBtn: ['변경', 'Change', 'Đổi', 'Изменить'],
  changed: ['핸들을 변경했어요', 'Handle updated', 'Đã đổi handle', 'Handle обновлён'],
  sameAsCurrent: [
    '현재 핸들과 같아요',
    'Same as current handle',
    'Giống handle hiện tại',
    'Совпадает с текущим handle',
  ],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return { handle: pick(handle, langIndex) };
}

export const phaseHandleH0Ko = buildLang(0);
export const phaseHandleH0En = buildLang(1);
export const phaseHandleH0Vi = buildLang(2);
export const phaseHandleH0Ru = buildLang(3);
